// extracted by mini-css-extract-plugin
export default {"AccountContent":"AdsPricing_AccountContent__leTiv","btn__deactive":"AdsPricing_btn__deactive__TD4vI","btn__delete":"AdsPricing_btn__delete__jh-yS"};